import generatePicker, { PickerProps } from 'antd/es/date-picker/generatePicker';
// eslint-disable-next-line import/no-extraneous-dependencies
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import dayjs, { Dayjs } from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import { genTestID } from '../../utils/utils';
import styles from './inputs.module.less';

dayjs.extend(weekday);

interface TaggedDatePickerOwnProps {
  tag: string;
  showTime?: boolean;
}

const DayjsDatePicker = generatePicker<Dayjs>(dayjsGenerateConfig);

type TaggedDatePickerProps = PickerProps<Dayjs> & TaggedDatePickerOwnProps;

const TaggedDatePicker = (props: TaggedDatePickerProps) => {
  const { tag, value, showTime = false } = props;

  const dateFormat = showTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';

  return (
    <DayjsDatePicker
      {...props}
      inputReadOnly
      data-testid={genTestID('datePicker', tag)}
      format={dateFormat}
      className={styles['full-width']}
      value={value ? dayjs(value) : value}
    />
  );
};

export default TaggedDatePicker;
